module.exports = __webpack_public_path__ + "static/media/icon_custom_location_special_generic_purple.81e72a47.svg";